import { Box, Button, SxProps, Theme } from '@mui/material';

import { useLanguage } from '../../hooks';

export interface SignersDrawerFooterProps {
  onCancelButtonClick: () => void;
  onAddButtonClick: () => void;
  addButtonDisabled?: boolean;
}

const customStyles: Record<string, SxProps<Theme>> = {
  footerBox: {
    display: 'flex',
    justifyContent: 'flex-end',
    padding: '16px',
    gap: '16px',
    bgcolor: 'white',
    boxShadow: '0px -2px 8px rgba(0, 0, 0, 0.1)',
    borderTop: (theme) => `1px solid ${theme.palette.grey[300]}`,
  },
};

export function SignersDrawerFooter({
  onAddButtonClick,
  onCancelButtonClick,
  addButtonDisabled = false,
}: SignersDrawerFooterProps) {
  const lang = useLanguage();
  return (
    <Box sx={customStyles.footerBox}>
      <Button
        onClick={onCancelButtonClick}
        variant='outlined'
        color='secondary'
      >
        {lang.formSignatureBuilder.cancelButton}
      </Button>
      <Button
        onClick={onAddButtonClick}
        variant='contained'
        color='primary'
        disabled={addButtonDisabled}
      >
        {lang.formSignatureBuilder.addButton}
      </Button>
    </Box>
  );
}

export default SignersDrawerFooter;
